import React from 'react';

/**
 * Component to truncate long names and show full name on hover
 * @param {string} name - The name to display
 * @param {number} maxLength - Maximum length before truncation (default: 20)
 * @param {string} className - Additional CSS classes
 * @param {React.ReactNode} children - Optional children element to wrap (e.g., <p>, <Link>)
 */
const TruncatedName = ({ name, maxLength = 20, className = '', children = null }) => {
  if (!name) {
    if (children) {
      return React.cloneElement(children, { children: null });
    }
    return null;
  }

  const shouldTruncate = name.length > maxLength;
  const displayName = shouldTruncate ? `${name.substring(0, maxLength)}...` : name;

  // If children provided, clone it with the truncated name
  if (children) {
    const childProps = {
      ...children.props,
      children: displayName,
      ...(shouldTruncate && { title: name })
    };
    
    return React.cloneElement(children, childProps);
  }

  // No children, return simple span
  if (shouldTruncate) {
    return (
      <span 
        className={`${className} cursor-help`}
        title={name}
      >
        {displayName}
      </span>
    );
  }

  return <span className={className}>{displayName}</span>;
};

export default TruncatedName;

